import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  paymentMethodFromModel,
  validatePaymentMethodCondition,
  type PaymentMethodState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PAYMENT_METHOD = (
  Details: React.ComponentType<ConditionTypeDetailsProps<PaymentMethodState>>,
): ConditionType<PaymentMethodState, Condition.PaymentMethod> => ({
  name: "Original Payment Method",
  description(state) {
    return state !== undefined
      ? `Payment method was: ${state}`
      : "The payment method used for the original order";
  },
  Details(props: ConditionTypeDetailsProps<PaymentMethodState>) {
    return React.createElement(Details, props);
  },
  empty: null,
  fromModel(model) {
    return paymentMethodFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PAYMENT_METHOD, method: state };
  },
  valid(state) {
    return validatePaymentMethodCondition(state).valid;
  },
});

export { type PaymentMethodState } from "@redotech/redo-model/return-flow/condition-validate";
